var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_LoadingPool"),
                  name: "loadPool"
                }
              },
              [
                _c("load-pool", {
                  ref: "loadPool",
                  attrs: {
                    "airline-product-down-list": _vm.airlineProductDownList,
                    source: _vm.SystemConstants.LOAD_POOL_SOURCE_HOME_PAGE.code
                  },
                  on: { saveAssemblyPlanSuccess: _vm.saveAssemblyPlanSuccess }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_AssemblyPlan"),
                  name: "assemblyPlan"
                }
              },
              [
                _c("assembly-plan", {
                  ref: "assemblyPlan",
                  attrs: {
                    "airline-product-down-list": _vm.airlineProductDownList
                  },
                  on: { saveAssemblyPlanSuccess: _vm.saveAssemblyPlanSuccess }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }